import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.docs');
import { OnInit, AfterViewChecked, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-docs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.docs/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
  overflow: auto;
  background: #ffffff;
  color: #111827;
}

.docs-shell {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: 0 20px;
}

.docs-shell--wide {
  width: min(100%, 1180px);
}

.docs-hub {
  min-height: 100%;
}

.docs-topbar {
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(18px);
  box-shadow: 0 20px 48px rgba(148, 163, 184, 0.1);
}

.docs-topbar__inner {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 24px 28px;
}

.docs-kicker {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.16);
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.docs-title {
  margin: 12px 0 0;
  font-size: 30px;
  line-height: 1.05;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #0f172a;
}

.docs-subtitle {
  margin: 10px 0 0;
  max-width: 720px;
  color: #475569;
  font-size: 14px;
  line-height: 1.7;
}

.docs-primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 999px;
  border: 0;
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}
.docs-primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.2);
}
.docs-primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.docs-hub__body {
  padding-top: 8px;
  padding-bottom: 36px;
}

.docs-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.75fr) minmax(280px, 1fr);
  gap: 18px;
  margin-bottom: 24px;
}

.docs-hero__main,
.docs-hero__metrics {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px);
  box-shadow: 0 22px 50px rgba(148, 163, 184, 0.12);
}

.docs-hero__main {
  padding: 28px;
}

.docs-hero__metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 18px;
}

.docs-hero__eyebrow {
  display: inline-flex;
  margin-bottom: 12px;
  color: #6366f1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.docs-hero__title {
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  letter-spacing: -0.04em;
  font-weight: 700;
  color: #111827;
}

.docs-hero__text {
  margin: 12px 0 0;
  max-width: 650px;
  color: #475569;
  font-size: 14px;
  line-height: 1.8;
}

.docs-metric {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  min-height: 120px;
  padding: 18px;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(241, 245, 249, 0.82) 100%);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.docs-metric__label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.docs-metric__value {
  color: #0f172a;
  font-size: 34px;
  line-height: 1;
  letter-spacing: -0.05em;
}

.docs-section {
  margin-bottom: 18px;
}

.docs-section__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
}

.docs-section__title {
  margin: 0;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  color: #0f172a;
}

.docs-section__text {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.7;
}

.docs-filter-rail {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.docs-filter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.8);
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
}
.docs-filter-chip:hover {
  border-color: rgba(129, 140, 248, 0.5);
  color: #3730a3;
}

.docs-filter-chip--active {
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.16);
}

.docs-state,
.docs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 260px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.75);
  box-shadow: 0 18px 40px rgba(148, 163, 184, 0.1);
}

.docs-state__text,
.docs-empty__text {
  color: #64748b;
  font-size: 14px;
}

.docs-empty__icon {
  width: 52px;
  height: 52px;
  color: #cbd5e1;
}

.docs-empty__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #334155;
}

.template-card {
  display: block;
}

.template-card__frame {
  position: relative;
}

.template-card__halo {
  position: absolute;
  inset: 18px;
  border-radius: 26px;
  background: linear-gradient(135deg, rgba(199, 210, 254, 0.6), rgba(253, 230, 138, 0.45));
  filter: blur(22px);
  opacity: 0;
  transition: opacity 0.28s ease;
}

.template-card:hover .template-card__halo {
  opacity: 1;
}

.template-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 16px;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0) 34%, rgba(15, 23, 42, 0.16) 100%);
  opacity: 0;
  transition: opacity 0.28s ease;
}

.template-card:hover .template-card__overlay {
  opacity: 1;
}

.template-card__cta {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #111827;
  font-size: 12px;
  font-weight: 700;
}

.template-card__meta {
  padding: 14px 6px 0;
}

.template-card__meta-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.template-card__category,
.template-card__hint {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.template-card__category {
  color: #6366f1;
}

.template-card__hint {
  color: #94a3b8;
  text-transform: uppercase;
}

.template-card__title {
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 700;
}

.template-card__text {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.7;
}

.docs-section--recent {
  margin-top: 28px;
}

.docs-table-card {
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 18px 45px rgba(148, 163, 184, 0.12);
}
.docs-table-card table {
  width: 100%;
  border-collapse: collapse;
}
.docs-table-card thead tr {
  background: rgba(248, 250, 252, 0.98);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}
.docs-table-card th,
.docs-table-card td {
  padding: 15px 18px;
  text-align: left;
  font-size: 13px;
}
.docs-table-card th {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.docs-table-card tbody tr {
  cursor: pointer;
  transition: background 0.2s ease;
}
.docs-table-card tbody tr + tr {
  border-top: 1px solid rgba(241, 245, 249, 0.95);
}
.docs-table-card tbody tr:hover {
  background: rgba(248, 250, 252, 0.9);
}

.docs-table-card__title {
  color: #0f172a;
  font-weight: 600;
}

.docs-mobile-card {
  padding: 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 12px 28px rgba(148, 163, 184, 0.12);
}

.docs-mobile-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.docs-mobile-card__title {
  margin: 0;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 700;
}

.docs-mobile-card__meta,
.docs-mobile-card__date {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 12px;
}

.docs-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.docs-status--done {
  background: rgba(220, 252, 231, 0.95);
  color: #15803d;
}

.docs-status--draft {
  background: rgba(254, 249, 195, 0.95);
  color: #a16207;
}

.thumbnail-wrapper {
  position: relative;
  width: 100%;
  padding-top: 141.4%;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.thumbnail-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 700px;
  transform-origin: top left;
  transform: scale(var(--thumb-scale, 0.28));
  pointer-events: none;
  user-select: none;
  padding: 30px 40px;
  box-sizing: border-box;
}

::ng-deep .thumbnail-content .doc-container {
  font-family: "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif;
  max-width: 700px;
  margin: 0 auto;
  color: #000;
  font-size: 12pt;
  line-height: 1.6;
}
::ng-deep .thumbnail-content .doc-container * {
  font-family: inherit !important;
}
::ng-deep .thumbnail-content .doc-header-top {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
::ng-deep .thumbnail-content .doc-header-top .logo-area {
  flex-shrink: 0;
  width: 90px;
}
::ng-deep .thumbnail-content .doc-header-top .logo-area img {
  width: 80px;
  height: auto;
}
::ng-deep .thumbnail-content .doc-header-top .company-name {
  flex: 1;
  text-align: center;
  font-size: 18pt;
  font-weight: bold;
  letter-spacing: 2px;
}
::ng-deep .thumbnail-content .doc-header-top .header-right {
  flex-shrink: 0;
  width: 90px;
}
::ng-deep .thumbnail-content .doc-confidential {
  text-align: center;
  font-size: 8pt;
  color: #555;
}
::ng-deep .thumbnail-content .doc-classify {
  font-size: 12pt;
}
::ng-deep .thumbnail-content .doc-classify .classify-label {
  color: #c75252;
}
::ng-deep .thumbnail-content .doc-field-row {
  display: flex;
  font-size: 12pt;
  line-height: 1.6;
}
::ng-deep .thumbnail-content .doc-field-label {
  font-weight: normal;
  min-width: 44px;
}
::ng-deep .thumbnail-content .doc-field-label-colored {
  color: #c75252;
}
::ng-deep .thumbnail-content .doc-field-value {
  flex: 1;
}
::ng-deep .thumbnail-content .doc-subject-row {
  display: flex;
  font-size: 12pt;
  line-height: 1.6;
  padding-bottom: 6px;
  border-bottom: 1px solid #000;
}
::ng-deep .thumbnail-content .doc-body {
  font-size: 12pt;
  line-height: 1.8;
  clear: both;
}
::ng-deep .thumbnail-content .doc-sign-block {
  margin-top: 24px;
  text-align: center;
}
::ng-deep .thumbnail-content .doc-sign-block .sign-title {
  font-size: 15pt;
  font-weight: bold;
}
::ng-deep .thumbnail-content .doc-sign-block .sign-sub {
  font-size: 8pt;
  color: #555;
}
::ng-deep .thumbnail-content .approval-table {
  border-collapse: collapse;
  font-size: 8pt;
  margin: 0 auto;
}
::ng-deep .thumbnail-content .approval-table th, ::ng-deep .thumbnail-content .approval-table td {
  border: none;
  text-align: center;
  padding: 2px 8px;
  min-width: 52px;
}
::ng-deep .thumbnail-content .approval-table .ap-label {
  font-weight: normal;
  height: 20px;
}
::ng-deep .thumbnail-content .approval-table .ap-sign {
  height: 40px;
  font-size: 10pt;
}
::ng-deep .thumbnail-content .approval-table .ap-date {
  font-size: 8pt;
  height: 18px;
}
::ng-deep .thumbnail-content .doc-footer {
  margin-top: 20px;
  font-size: 8pt;
}
::ng-deep .thumbnail-content .doc-footer-divider {
  height: 8px;
  background: #cccccc;
  margin-bottom: 4px;
}
::ng-deep .thumbnail-content .doc-footer-row {
  display: flex;
  margin-bottom: 1px;
}
::ng-deep .thumbnail-content .doc-footer-label {
  min-width: 50px;
}
::ng-deep .thumbnail-content .doc-footer-value {
  flex: 1;
}
::ng-deep .thumbnail-content .doc-footer-right {
  text-align: right;
}
::ng-deep .thumbnail-content .doc-title-center {
  text-align: center;
  font-size: 20pt;
  font-weight: bold;
  letter-spacing: 8px;
  margin: 24px 0;
}
::ng-deep .thumbnail-content .doc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12pt;
}
::ng-deep .thumbnail-content .doc-table th, ::ng-deep .thumbnail-content .doc-table td {
  border: 1px solid #000;
  padding: 6px 10px;
}
::ng-deep .thumbnail-content .doc-table th {
  background: #f7f7f7;
  font-weight: 600;
  width: 110px;
  text-align: center;
}
::ng-deep .thumbnail-content .doc-cert-statement {
  text-align: center;
  font-size: 14pt;
  margin: 24px 0;
}
::ng-deep .thumbnail-content .doc-date-center {
  text-align: center;
  font-size: 12pt;
  margin: 16px 0 8px 0;
}
::ng-deep .thumbnail-content .doc-sign-area {
  text-align: center;
  margin-top: 24px;
  font-size: 14pt;
  line-height: 2;
}
::ng-deep .thumbnail-content .doc-sign-area .org-name {
  font-weight: bold;
  font-size: 15pt;
}
::ng-deep .thumbnail-content .doc-sign-area .seal-text {
  font-size: 10pt;
  color: #888;
}
::ng-deep .thumbnail-content .doc-dual-sign {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
  font-size: 12pt;
}
::ng-deep .thumbnail-content .doc-dual-sign .sign-block {
  text-align: center;
  line-height: 2;
}
::ng-deep .thumbnail-content .doc-check-table {
  width: 100%;
  border-collapse: collapse;
}
::ng-deep .thumbnail-content .doc-check-table th, ::ng-deep .thumbnail-content .doc-check-table td {
  border: 1px solid #000;
  padding: 5px 8px;
  font-size: 12pt;
}
::ng-deep .thumbnail-content .doc-check-table th {
  background: #f7f7f7;
  font-weight: 600;
  text-align: center;
}
::ng-deep .thumbnail-content .doc-check-table td {
  text-align: center;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-report {
  font-size: 11pt;
  line-height: 1.7;
  letter-spacing: -0.01em;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-report .doc-header-gap {
  height: 76px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-report .doc-body {
  font-size: 11pt;
  line-height: 1.7;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table {
  font-family: "SeasonDocumentDotum", "돋움체", "DotumChe", "돋움", Dotum, sans-serif;
  font-size: 10pt;
  line-height: 1.45;
  letter-spacing: 0;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-header-gap {
  height: 64px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-classify, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-field-row, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-subject-row, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-body, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-table, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-check-table {
  font-size: 10pt;
  line-height: 1.45;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-table th, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-table td, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-check-table th, ::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-check-table td {
  padding: 4px 7px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-table th {
  width: 92px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-table .doc-title-center {
  font-size: 18pt;
  margin: 18px 0;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert {
  font-family: "SeasonDocumentBatang", "바탕체", "BatangChe", "바탕", Batang, serif;
  font-size: 11pt;
  line-height: 1.75;
  letter-spacing: 0;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-header-gap {
  height: 56px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-title-center {
  font-size: 21pt;
  letter-spacing: 10px;
  margin: 32px 0 24px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-body, ::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-table {
  font-size: 11pt;
  line-height: 1.75;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-cert-statement {
  font-size: 13pt;
  margin: 30px 0 18px;
  line-height: 1.9;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-date-center {
  font-size: 11pt;
  margin-top: 22px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-cert .doc-sign-area {
  font-size: 13pt;
  margin-top: 22px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract {
  font-family: "SeasonDocumentBatang", "바탕체", "BatangChe", "바탕", Batang, serif;
  font-size: 11pt;
  line-height: 1.75;
  letter-spacing: 0;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-header-gap {
  height: 52px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-title-center {
  font-size: 20pt;
  letter-spacing: 8px;
  margin: 26px 0 20px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-body, ::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-clause, ::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-dual-sign {
  font-size: 11pt;
  line-height: 1.75;
  text-align: justify;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-table {
  font-size: 10.5pt;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-table th, ::ng-deep .thumbnail-content .doc-container.doc-kind-contract .doc-table td {
  padding: 5px 8px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application {
  font-size: 11pt;
  line-height: 1.55;
  letter-spacing: -0.01em;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-header-gap {
  height: 60px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-title-center {
  font-size: 19pt;
  letter-spacing: 6px;
  margin: 22px 0 18px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-body, ::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-table, ::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-field-row, ::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-subject-row {
  font-size: 11pt;
  line-height: 1.55;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-table th {
  width: 96px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-table th, ::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-table td {
  padding: 5px 8px;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-cert-statement {
  font-size: 12pt;
  margin: 20px 0 12px;
  line-height: 1.7;
}
::ng-deep .thumbnail-content .doc-container.doc-kind-application .doc-sign-area {
  font-size: 12pt;
  margin-top: 18px;
}

@media (max-width: 960px) {
  :host {
    --page-white-zone: 300px;
  }
  .docs-topbar__inner,
  .docs-section__head {
    flex-direction: column;
    align-items: flex-start;
  }
  .docs-hero {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  :host {
    --page-white-zone: 260px;
  }
  .docs-shell,
  .docs-shell--wide {
    padding: 0 14px;
  }
  .docs-hub__body {
    padding-top: 4px;
  }
  .docs-title {
    font-size: 24px;
  }
  .docs-subtitle,
  .docs-hero__text,
  .docs-section__text {
    font-size: 13px;
  }
  .docs-hero__main {
    padding: 22px 18px;
  }
  .docs-topbar__inner {
    padding: 22px 18px;
  }
  .docs-hero__metrics {
    grid-template-columns: 1fr 1fr;
    padding: 14px;
  }
  .docs-metric {
    min-height: 100px;
    padding: 14px;
  }
  .docs-metric__value {
    font-size: 28px;
  }
}`],
})
export class PageDocsComponent implements OnInit, AfterViewChecked, OnDestroy {
    public categories: string[] = [];
    public templates: any[] = [];
    public recentDocs: any[] = [];
    public selectedCategory: string = '';
    public loading: boolean = true;

    private scaleApplied: boolean = false;
    private resizeHandler: any;

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.resizeHandler = () => { this.scaleApplied = false; };
        window.addEventListener('resize', this.resizeHandler);
        await this.load();
    }

    ngAfterViewChecked() {
        if (!this.scaleApplied && this.templates.length > 0) {
            this.updateThumbnailScale();
        }
    }

    ngOnDestroy() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }

    private updateThumbnailScale() {
        const wrapper = document.querySelector('.thumbnail-wrapper') as HTMLElement;
        if (wrapper && wrapper.clientWidth > 0) {
            const scale = wrapper.clientWidth / 700;
            document.querySelectorAll('.thumbnail-wrapper').forEach((el: any) => {
                el.style.setProperty('--thumb-scale', String(scale));
            });
            this.scaleApplied = true;
        }
    }

    public async load() {
        this.loading = true;
        this.scaleApplied = false;
        await this.service.render();

        try {
            const catRes = await wiz.call("categories");
            if (catRes.code === 200) {
                this.categories = catRes.data.data || [];
            }

            const tplRes = await wiz.call("templates", { category: this.selectedCategory });
            if (tplRes.code === 200) {
                const rows = tplRes.data.data || [];
                for (const tpl of rows) {
                    const html = tpl.template_content || '<div style="padding:40px;text-align:center;color:#ccc;font-size:14px;">미리보기 없음</div>';
                    tpl._safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
                }
                this.templates = rows;
            }

            const recentRes = await wiz.call("recent_docs", { page: 1, dump: 5 });
            if (recentRes.code === 200) {
                this.recentDocs = recentRes.data.data || [];
            }
        } catch (e) {
            console.error('load error:', e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async filterByCategory(category: string) {
        this.selectedCategory = category;
        await this.load();
    }

    public openForm(template: any) {
        this.service.href(`/docs/form/${template.id}`);
    }

    public viewDocument(doc: any) {
        this.service.href(`/docs/form/${doc.template_id}?doc_id=${doc.id}`);
    }
}

export default PageDocsComponent;